export default class microbaAnalytics {
  static trackItemsAdded (id = 1, name, price, quantity, category, coupon) {
    if (process.env.ANALYTICS_TRACKING === 'true') {
      const product = this.getProduct(id, name, price, quantity, category, coupon)
      // eslint-disable-next-line
      dataLayer.push({
        'event': 'kit added to cart.',
        'ecommerce': {
          'currencyCode': 'AUD',
          'add': {
            'products': [product]
          }
        }
      })
      this.trackCheckout(1, product)
    }
  }

  static trackCheckout (step, product) {
    if (process.env.ANALYTICS_TRACKING === 'true') {
      // eslint-disable-next-line
      dataLayer.push({
        'event': 'checkout',
        'ecommerce': {
          'checkout': {
            'actionField': { 'step': step, 'option': step },
            'products': [product]
          }
        }
      })
    }
  }

  static getProduct (id = 1, name, price, quantity, category, coupon) {
    const product = {
      'name': name,
      'id': id,
      'price': price,
      'brand': 'Microba',
      'category': category,
      'variant': category,
      'quantity': quantity,
      'coupon': coupon
    }
    return product
  }

  static trackPurchase (transactionId, id = 1, name, price, quantity, category, coupon, revenue) {
    if (process.env.ANALYTICS_TRACKING === 'true') {
      const product = this.getProduct(id, name, price, quantity, category, coupon)
      // eslint-disable-next-line
      dataLayer.push({
        'event': 'purchase',
        'ecommerce': {
          'purchase': {
            'actionField': {
              'id': transactionId,
              'affiliation': 'Discover Portal',
              'coupon': coupon,
              'revenue': revenue
            },
            'products': [product]
          }
        }
      })
    }
  }
}



// WEBPACK FOOTER //
// ./src/services/microbaAnalytics.js